export function getCurrency(brandId: number): string {
  switch (brandId) {
    case 16: return '฿';
    case 10: return '£';
    case 20: return 'CHF';
    default: return '€';
  }
}
